import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    CardBody,
    Col,
    Row,
    Badge,
    Button,
    Container,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label,Input
} from "reactstrap";
import { listApplications } from "../../../slices/veloxity/pushNotification/listApplication";
import { createApplication } from "../../../slices/veloxity/pushNotification/createApplication";
import { deleteApplication } from "../../../slices/veloxity/pushNotification/deleteApplication"; // Import delete reducer
import showConfirmationAlert from "../../../components/custom/confirmationAlert"; // Import confirmation alert
import Loader from "../../../components/common/Loader";
import FeatherIcon from "feather-icons-react";
import BreadCrumb from "../../../components/common/BreadCrumb";
import { showErrorAlert,showSuccessAlert } from "../../../components/custom/sweetalertHelper";

const NotificationApplications = () => {
    const dispatch = useDispatch();

    const [searchTerm, setSearchTerm] = useState("");

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase()); // Arama terimini küçük harfe çevirerek eşleştirmeyi iyileştirir
    };

    const { loading: listLoading, applications, error } = useSelector(
        (state) => state.listApplications
    );
    const { loading: createLoading } = useSelector(
        (state) => state.createApplication
    );

    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        licence: "",
        appUid: "",
        certificateBase64: "",
    });

    useEffect(() => {
        dispatch(listApplications());
    }, [dispatch]);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const jsonData = JSON.parse(reader.result);
                    const base64Data = btoa(JSON.stringify(jsonData));
                    setFormData({ ...formData, certificateBase64: base64Data });
                } catch (error) {
                    console.error("Invalid JSON file format");
                    showErrorAlert("Invalid JSON", error.message || "Invalid JSON file format. Please upload a valid JSON file.");
                }
            };
            reader.readAsText(file);
        }
    };

    const handleSubmit = () => {
        const { name, licence, appUid, certificateBase64 } = formData;
        dispatch(
            createApplication({
                requestData: { name, licence, appUid, certificateBase64 },
            })
        )
            .then(() => {
                showSuccessAlert("Application Created", "The application was created successfully.");
                dispatch(listApplications());
            })
            .catch((error) => {
                showErrorAlert("Error Creating Application", error.message || "An error occurred while creating the application.");
            });
        setModalOpen(false);
    };
    
    const handleDelete = (appId, appName) => {
        showConfirmationAlert(`Are you sure you want to delete the application "${appName}"?`, () => {
            dispatch(deleteApplication({ applicationId: appId }))
                .then(() => {
                    showSuccessAlert("Application Deleted", `The application "${appName}" was deleted successfully.`);
                    dispatch(listApplications()); // Refresh the list after deletion
                })
                .catch((error) => {
                    showErrorAlert("Error Deleting Application", error.message || "An error occurred while deleting the application.");
                });
        });
    };
    

    // Filtrelenmiş uygulamaları hesapla
    const filteredApplications = applications?.filter(
        (app) =>
            app.name.toLowerCase().includes(searchTerm) ||
            app.licence.toLowerCase().includes(searchTerm) ||
            app.appUid.toLowerCase().includes(searchTerm)
    );

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Notification Applications" pageTitle="Sales Growth" />

                    {/* Top Controls */}
                    <Row className="g-4 mb-4">
                        {/* Add Button */}
                        <div className="col-sm-auto">
                            <Button color="success" onClick={toggleModal}>
                                <i className="ri-add-line align-bottom me-1"></i> New Application
                            </Button>
                        </div>

                        {/* Search Box */}
                        <div className="col-sm-3 ms-auto">
                            <div className="d-flex justify-content-sm-end gap-2">
                                <div className="search-box ms-2 col-sm-7">
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <i className="ri-search-line search-icon"></i>
                                </div>
                            </div>
                        </div>
                    </Row>

                    {/* List Applications */}
                    <Row>
                        {listLoading ? (
                            <Loader />
                        ) : error ? (
                            <div className="text-danger">
                                <p>Error: {error}</p>
                            </div>
                        ) : filteredApplications && filteredApplications.length > 0 ? (
                            filteredApplications.map((app) => (
                                <Col xxl={3} sm={6} className="mb-4" key={app.id}>
                                    <Card className="card-height-100">
                                        <CardBody>
                                            <div className="d-flex flex-column h-100">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    {/* App Name in the top-left */}
                                                    <h5 className="mb-1 fs-16 flex-grow-1">{app.name}</h5>
                                                    {/* Badge and Dropdown in the top-right */}
                                                    <div className="d-flex align-items-center">
                                                        <Badge
                                                            color={app.enabled ? "success" : "danger"}
                                                            className="me-2"
                                                        >
                                                            {app.enabled ? "Active" : "Inactive"}
                                                        </Badge>
                                                        <UncontrolledDropdown direction="start">
                                                            <DropdownToggle
                                                                tag="button"
                                                                className="btn btn-link text-muted p-0 text-decoration-none fs-15"
                                                            >
                                                                <FeatherIcon
                                                                    icon="more-horizontal"
                                                                    className="icon-sm"
                                                                />
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                                <DropdownItem onClick={() => handleDelete(app.id, app.name)}>
                                                                    <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                                                                    Delete
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </div>
                                                </div>
                                                <div style={{ paddingTop: "10px" }}>
                                                    <p className="text-muted mb-2">
                                                        <strong>Licence:</strong> {app.licence}
                                                    </p>
                                                    <p className="text-muted mb-2">
                                                        <strong>App UID:</strong> {app.appUid}
                                                    </p>
                                                    <p className="text-muted">
                                                        <strong>Created:</strong>{" "}
                                                        {new Date(app.createDate).toLocaleString()}
                                                    </p>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <p>No applications found.</p>
                        )}
                    </Row>

                    {/* Create Modal */}
                    <Modal isOpen={modalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Create Application</ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Label for="name">Application Name</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Enter application name"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="licence">Licence</Label>
                                <Input
                                    type="text"
                                    name="licence"
                                    id="licence"
                                    value={formData.licence}
                                    onChange={handleInputChange}
                                    placeholder="Enter licence"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="appUid">App UID</Label>
                                <Input
                                    type="text"
                                    name="appUid"
                                    id="appUid"
                                    value={formData.appUid}
                                    onChange={handleInputChange}
                                    placeholder="Enter App UID"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="certificateFile">Upload Certificate JSON</Label>
                                <Input
                                    type="file"
                                    name="certificateFile"
                                    id="certificateFile"
                                    accept=".json"
                                    onChange={handleFileChange}
                                />
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={handleSubmit}
                                disabled={createLoading}
                            >
                                {createLoading ? "Creating..." : "Create"}
                            </Button>
                            <Button color="secondary" onClick={toggleModal}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NotificationApplications;
